<vectronic-status-select
  [value]="value()"
  [options]="options()"
  [editable]="editable()"
  [placeholder]="placeholder()"
  [emptySymbol]="emptySymbol()"
  [searchable]="searchable()"
  (valueChange)="onSelect($event)"
/>
